// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'https://accesoinformacion.uncp.edu.pe/api',
  appName: 'Sistema de Acceso a la Información Pública UNCP',
  oficina: 'Oficina de Tecnologías de la Información',
  institucion: 'Universidad Nacional del Centro del Perú',
  version: '1.0.0',
  enableLogging: true,
  enableDebugMode: true
};
